import {
  NeutralColors,
  Link,
  MessageBar,
  MessageBarType,
} from "@fluentui/react";
import { Text } from "@fluentui/react/lib/Text";
import { TextField } from "@fluentui/react/lib/TextField";
import { PrimaryButton, CompoundButton } from "@fluentui/react/lib/Button";
import React, { useContext, useEffect, useState } from "react";
import AuthService from "../../services/authService";
import { IUser, IMicrosoft } from "../../auth/interface/IAuth";
import { AuthContext } from "../../auth/context/auth-context";
import { useNavigate } from "react-router-dom";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";
import MicrosoftLogin from "react-microsoft-login";
import { UseForm } from "../../hooks/useForm";
import { initialUrl } from "../../utils/helpers/helpers";
import { IException } from "../../Interfaces/base/IBase";
import {
  siteKey,
  urlRecuperarContraseniaIdentidad,
} from "../../services/http-common";
import { useMsal } from "@azure/msal-react";
import { ButtonLoginMicrosoft } from "../buttonLogin/ButtonLoginMicrosoft";
import { UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "../../utils/helpers/authConfig";
import { AccountInfo } from "@azure/msal-browser";

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        execute: (
          siteKey: string,
          options: { action: string }
        ) => Promise<string>;
      };
    };
  }
}

export const Login = () => {
  const { instance: msalInstance } = useMsal();

  const { signin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [verLoading, setVerLoading] = useState(false);
  const [excepcion, setExcepcion] = useState(null);
  const [exp, setExp] = useState(0);
  const [mensajeRespuesta, setMensajeRespuesta] = useState<string>(null!);
  const { email, password, tokenCaptcha, form, _handleChange } = UseForm<IUser>(
    {
      email: "",
      password: "",
      tokenCaptcha: "",
    }
  );

  const handleLoginClickMS = async () => {
    try {
      // -->setLoginProgresMicrosoft(true); // Inicia progreso al hacer click
      setVerLoading(true);
      await msalInstance.loginRedirect({
        ...loginRequest,
        prompt: "select_account",
      });
    } catch (error) {
      // -->setLoginProgresMicrosoft(false); // Si falla, termina progreso
      setVerLoading(false);
      console.error("❌ Login failed!", error);
    }
  };

  // const _pressLogin = (
  //   ev?: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   if (ev != undefined) {
  //     if (ev.code === "Enter" || ev.code === "NumpadEnter") {
  //       _handleLogin();
  //     }
  //   }
  // };

  const _handleLogin = (token: string) => {
    setVerLoading(true);
    const updatedForm = { ...form, tokenCaptcha: token };
    AuthService.login(updatedForm)
      .then((response) => {
        if (response.status == 200) {
          let res = JSON.parse(response.request.response);
          if (res.succeeded) {
            if (res.accessToken != undefined && res.accessToken !== "") {
              signin(
                {
                  username: email,
                  token: res.accessToken,
                },
                () => window.location.replace(initialUrl)
                //(window.location.href = initialUrl)
                //navigate(initialUrl, { replace: true })
              );
            }
          }
        } else {
          console.log("esta es la respuesta", response);
        }
        //setVerLoading(false);
      })
      .catch((e: IException) => {
        if (e !== undefined) {
          //console.log(e.response);
          let rpta = e.response.data ? e.response.data : "";
          if (e.response.status === 400 && rpta === "Captcha no válido") {
            // let rpt = e.response.data
            //   ? e.response.data
            //   : "El captcha no pudo ser validado";
            //setMensajeRespuesta(rpt.toString());
            setMensajeRespuesta("El captcha no pudo ser validado");
          } else {
            let respuestaError =
              e.response?.data?.detail?.split("\n")[0] ??
              "Ingrese credenciales válidas";
            setMensajeRespuesta(respuestaError);
          }
          //console.log(e.response);
          // setVerLoading(false);
        }
      })
      .finally(() => {
        setVerLoading(false);
      });
  };

  // const responseMicrosoft = (err: any, data: any) => {
  //   console.log(err, data);
  //   if (data) {
  //     if (data.idTokenClaims) {
  //       let tokenReceived: IMicrosoft = {
  //         appid: data.idTokenClaims.aud,
  //         exp: data.idTokenClaims.exp as number,
  //         unique_name: data.idTokenClaims.preferred_username,
  //       };
  //       if (exp != tokenReceived.exp) {
  //         setExp(tokenReceived.exp);
  //         _handleLoginMicrosoft(tokenReceived);
  //       }
  //       setExp(tokenReceived.exp);
  //     }
  //   }
  // };

  const _handleLoginMicrosoft = (token: IMicrosoft) => {
    setVerLoading(true);
    AuthService.loginMicrosoft(token)
      .then((response) => {
        console.log(response);
        if (response.status == 200) {
          let res = JSON.parse(response.request.response);
          if (res.succeeded) {
            setExcepcion(null);
            if (res.accessToken != undefined && res.accessToken !== "") {
              signin(
                {
                  username: token.unique_name,
                  token: res.accessToken,
                },
                () => navigate(initialUrl, { replace: true })
              );
            }
          } else {
            setExcepcion(res.exception);
          }
        }
        setVerLoading(false);
      })
      .catch((e: Error) => {
        console.log(e);
        if (e != undefined) {
          setExcepcion(e.message as any);
        }
        setVerLoading(false);
      });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    // Aquí puedes verificar la respuesta del reCaptcha y enviar el formulario
    window.grecaptcha.enterprise
      .execute(siteKey, { action: "submit" })
      .then((token: string) => {
        // Aquí puedes verificar la respuesta del reCaptcha utilizando el token
        if (token) {
          // El reCaptcha se ha completado, puedes enviar el formulario
          // También puedes enviar el token a tu servidor para su verificación adicional si es necesario
          //console.log("Token de reCaptcha:", token);
          _handleLogin(token);
          // Aquí puedes enviar el formulario o realizar otras acciones
        } else {
          // El reCaptcha no se ha completado, puedes mostrar un mensaje de error
          console.log("El reCaptcha no se ha completado");
        }
      });
  };

  useEffect(() => {
    const container = document.getElementById("recaptcha-container");
    if (container) {
      // Inicializar reCaptcha aquí
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  // Luego, cuando el usuario vuelve del redirect, obtienes el token:
  const handleAfterRedirect = async () => {
    try {
      // 🟢 Aseguramos que está inicializado correctamente
      await msalInstance.initialize();

      const redirectResult = await msalInstance.handleRedirectPromise();

      if (redirectResult) {
        msalInstance.setActiveAccount(redirectResult.account);
        console.log(
          "✅ Usuario activo desde redirect:",
          redirectResult.account?.username
        );
      }

      let account = msalInstance.getActiveAccount();
      if (!account) {
        const allAccounts = msalInstance.getAllAccounts();
        if (allAccounts.length > 0) {
          account = allAccounts[0];
          msalInstance.setActiveAccount(account);
          console.log("✅ Usuario activo desde caché:", account.username);
        }
      }

      if (!account) {
        console.warn("⚠️ No hay cuenta activa después del redirect.");
        return;
      }

      const tokenResponse = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account,
      });
      //console.log("✅ Access Token obtenido:", tokenResponse);
      const tokenReceived: IMicrosoft = {
        appid: tokenResponse.account?.idTokenClaims?.aud ?? "",
        exp: tokenResponse.account?.idTokenClaims?.exp ?? 0,
        unique_name:
          tokenResponse.account?.idTokenClaims?.preferred_username ?? "",
        token: tokenResponse.accessToken, // This is the crucial part - passing the access token
      };
      // _handleLoginMicrosoft({ token: tokenResponse.accessToken });
      _handleLoginMicrosoft(tokenReceived);
    } catch (error) {
      console.error("❌ Error al manejar redirect:", error);
    }
  };

  useEffect(() => {
    const init = async () => {
      await msalInstance.initialize();
      handleAfterRedirect();
    };
    init();
  }, []);

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm6 ms-md8 ms-lg7"
            style={{
              backgroundImage: `url("../backGroundSsoma.png")`, //IMAGEN DE FONDO
              height: "100vh",
              backgroundSize: "cover",
              backgroundPosition: "right",
            }}
          ></div>
          <div
            className="ms-Grid-col ms-sm6 ms-md4 ms-lg5"
            style={{
              backgroundColor: NeutralColors.gray30,
              height: "100vh",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              {!verLoading && (
                <div
                  style={{
                    minWidth: 350,
                    minHeight: 500,
                  }}
                >
                  <Text className="ms-fontSize-42">Ingresar</Text>
                  <br></br>
                  <br></br>
                  {mensajeRespuesta != null && (
                    <MessageBar
                      messageBarType={MessageBarType.error}
                      isMultiline={false}
                      dismissButtonAriaLabel="Close"
                    >
                      {mensajeRespuesta}
                    </MessageBar>
                  )}
                  <br></br>
                  <div id="recaptcha-container">
                    <form onSubmit={handleSubmit}>
                      <TextField
                        label="Usuario"
                        name="email"
                        placeholder="Usuario"
                        autoComplete="off"
                        value={email}
                        onChange={_handleChange}
                        //onKeyPress={_pressLogin}
                      />
                      <TextField
                        label="Contraseña"
                        type="password"
                        name="password"
                        placeholder="Contraseña"
                        canRevealPassword
                        revealPasswordAriaLabel="Ver contraseña"
                        autoComplete="off"
                        value={password}
                        onChange={_handleChange}
                        //onKeyPress={_pressLogin}
                      />
                      <br></br>
                      <PrimaryButton
                        ariaDescription="Ingresar."
                        type="submit"
                        //onClick={_handleLogin}
                      >
                        Ingresar
                      </PrimaryButton>
                    </form>
                  </div>

                  <br></br>
                  <br></br>
                  <Link href={urlRecuperarContraseniaIdentidad}>
                    Recuperar Contraseña
                  </Link>
                  <br></br>
                  <br></br>
                  <br></br>
                  <div>
                    {/* LOGIN ANTERIOR */}

                    {/* <MicrosoftLogin
                      //clientId="01144f97-a8ce-47ea-962c-5d71f18344cb"
                      clientId="f0649dd0-4f56-4da1-ae0f-52686fe23ab7"
                      authCallback={responseMicrosoft}
                      withUserData={true}
                      forceRedirectStrategy={true}
                      children
                    />
                    /> */}

                    {/* <button></button> */}
                    {/* <CompoundButton onClick={handleLogin} style={{width:"100%",padding:'0'}}>
                      <div style={{ display: "flex", alignItems: "center",padding:'0' }}>
                        <div style={{marginRight:"8px"}}>
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="28" height="28" viewBox="0 0 48 48">
                            <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)"></path><path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)"></path><path fill="#ffc107" d="M26 26H42V42H26z" transform="rotate(-180 34 34)"></path><path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)"></path>
                          </svg>
                        </div>
                        <div style={{fontWeight:"bold"}}>
                          Sign in with Microsoft
                        </div>
                      </div>
                    </CompoundButton> */}
                    <ButtonLoginMicrosoft onclick={handleLoginClickMS} />
                  </div>
                </div>
              )}
              {verLoading && (
                <>
                  <ProgressIndicator
                    barHeight={5}
                    label="Enviando información"
                    description="Favor Espere un momento"
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
